<backstage-error-state [code]="code"/>